"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var lodash_1 = require("lodash");
var React = require("react");
var ReactDOM = require("react-dom");
var Pvjs_1 = require("../Pvjs"); // Fix conflicting imports/exports
var WikiPathwaysDefaultDisplayStyle = require("../WikiPathways.style");
/**
 * Simple wrapper around the Pvjs react component.
 * Use this function to call Pvjs
 * @param selector: DOM Selector for the container in which to render the diagram
 * @param about: unique identifier for the pathway
 * @param [opts]
 * @param [opts.version=0]: Pathways at WikiPathways are versioned, e.g., WP1 has version 73346.
 * 													Version 0 mean latest.
 * @param [opts.src]: if pvjson for pathway cannot be obtained from about, give a
 * 						     	  URL where the pvjson for the pathway can be obtained.
 * @param [opts.customStyle]
 * @param [callback]: The callback to call with the reference to the Pvjs instance
 */
function loadDiagram(selector, about, opts, callback) {
    var ref = null;
    var props = lodash_1.defaults({}, opts, {
        about: 'http://identifiers.org/wikipathways/' + about,
        version: 0,
        customStyle: WikiPathwaysDefaultDisplayStyle,
        showPanZoomControls: true
    });
    var container = document.querySelector(selector);
    ReactDOM.render(React.createElement(Pvjs_1.Pvjs, __assign({}, props, { ref: function (pvjs) { return ref = pvjs; } })), container, function (_) {
        callback(ref);
    });
}
exports.loadDiagram = loadDiagram;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFuaWxsYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInZhbmlsbGEudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLGlDQUFrQztBQUNsQyw2QkFBK0I7QUFDL0Isb0NBQXNDO0FBQ3RDLGdDQUE4QyxDQUFDLGtDQUFrQztBQUNqRix1RUFBeUU7QUFVekU7Ozs7Ozs7Ozs7OztHQVlHO0FBQ0gscUJBQTRCLFFBQWdCLEVBQUUsS0FBYSxFQUFFLElBQVUsRUFBRSxRQUFjO0lBQ3RGLElBQUksR0FBRyxHQUFHLElBQUksQ0FBQztJQUNmLElBQU0sS0FBSyxHQUFHLGlCQUFRLENBQUMsRUFBRSxFQUFFLElBQUksRUFBRTtRQUNoQyxLQUFLLEVBQUUsc0NBQXNDLEdBQUcsS0FBSztRQUNyRCxPQUFPLEVBQUUsQ0FBQztRQUNWLFdBQVcsRUFBRSwrQkFBK0I7UUFDNUMsbUJBQW1CLEVBQUUsSUFBSTtLQUN6QixDQUFDLENBQUM7SUFDQSxJQUFJLFNBQVMsR0FBRyxRQUFRLENBQUMsYUFBYSxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQ2pELFFBQVEsQ0FBQyxNQUFNLENBQ1gsb0JBQUMsV0FBYSxlQUFLLEtBQUssSUFBRSxHQUFHLEVBQUUsVUFBQSxJQUFJLElBQUksT0FBQSxHQUFHLEdBQUcsSUFBSSxFQUFWLENBQVUsSUFBRyxFQUNwRCxTQUFTLEVBQ2YsVUFBQyxDQUFDO1FBQ0QsUUFBUSxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQ2QsQ0FBQyxDQUNFLENBQUM7QUFDTixDQUFDO0FBaEJELGtDQWdCQyJ9


//////////////////
// WEBPACK FOOTER
// ./src/wrappers/vanilla.tsx
// module id = 238
// module chunks = 0